namespace Matrix.Data {
    export interface CountryForm {
        CountryCode: Serenity.StringEditor;
        Name: Serenity.StringEditor;
        PrimaryCurrencyCode: Serenity.LookupEditor;
        Isocode3: Serenity.StringEditor;
        DefaultSortOrder: Serenity.IntegerEditor;
        CreatedBy: StaticTextBlock;
        CreatedWhen: ReadOnlyDateTime;
        UpdatedBy: StaticTextBlock;
        UpdatedWhen: ReadOnlyDateTime;
        Version: StaticTextBlock;
    }

    export class CountryForm extends Serenity.PrefixedContext {
        static formKey = 'Data.Country';
        private static init: boolean;

        constructor(prefix: string) {
            super(prefix);

            if (!CountryForm.init)  {
                CountryForm.init = true;

                var s = Serenity;
                var w0 = s.StringEditor;
                var w1 = s.LookupEditor;
                var w2 = s.IntegerEditor;
                var w3 = StaticTextBlock;
                var w4 = ReadOnlyDateTime;

                Q.initFormType(CountryForm, [
                    'CountryCode', w0,
                    'Name', w0,
                    'PrimaryCurrencyCode', w1,
                    'Isocode3', w0,
                    'DefaultSortOrder', w2,
                    'CreatedBy', w3,
                    'CreatedWhen', w4,
                    'UpdatedBy', w3,
                    'UpdatedWhen', w4,
                    'Version', w3
                ]);
            }
        }
    }
}
